import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { parseLinkMetadata } from 'site-modules/shared/utils/parse-content-metadata';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { SECTION_RELATED_CONTENT } from 'site-modules/shared/constants/top-rated/top-rated';
import { RelatedContent } from 'site-modules/shared/components/editorial/related-content/related-content';
import { VehicleCard } from './vehicle-card';

import './vehicle-section.scss';

export function VehicleSection({ entry, openVideoModal, isMobile = false }) {
  const anchorName = entry.metadata('anchorName').value();
  const cardTitle = entry.metadata('card-title').value();

  // video
  const videoEntry = entry.child('card-video');
  const videoId = videoEntry.metadata('youtube-videoid').value();
  const videoTitle = videoEntry.metadata('videoTitle').value();
  const videoTranscript = videoEntry.metadata('videoTranscript').value();
  const videoThumbnailUrl = videoEntry.metadata('thumbnailURL').value();
  const videoAspectRatio = videoEntry.metadata('aspectRatio').value();

  // vehicle title
  const vehicleTitleEntry = entry.child('vehicle-title');
  const vehicleLinkData = parseLinkMetadata(vehicleTitleEntry, 'vehicle');

  const vehicleContent = entry.child('vehicle-content').metadata('copyText').value();

  // buttons
  const buttonsEntry = entry.child('card-buttons');
  const primaryButtonData = parseLinkMetadata(buttonsEntry, 'button2');
  const secondaryButtonData = parseLinkMetadata(buttonsEntry, 'button1');

  // related content
  const relatedContentEntry = entry.child('segment-related-content');

  return (
    <ScrollElement id={anchorName} className="vehicle-section">
      <h2 className="heading-3 mb-1_5">{cardTitle}</h2>
      <VehicleCard
        vehicleContent={vehicleContent}
        videoId={videoId}
        videoTitle={videoTitle}
        videoAspectRatio={videoAspectRatio}
        videoTranscript={videoTranscript}
        videoThumbnailUrl={videoThumbnailUrl}
        primaryButtonData={primaryButtonData}
        secondaryButtonData={secondaryButtonData}
        vehicleLinkData={vehicleLinkData}
        openVideoModal={openVideoModal}
        isMobile={isMobile}
      />
      <RelatedContent
        entry={relatedContentEntry}
        titleClassName="heading-4 mb-0"
        config={SECTION_RELATED_CONTENT}
        isMobile={isMobile}
      />
    </ScrollElement>
  );
}

VehicleSection.propTypes = {
  entry: CmsEntities.Content.isRequired,
  openVideoModal: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};
